// extracted by mini-css-extract-plugin
module.exports = {"dialogs":"Dialogs_dialogs__HZJ_9","empty":"Dialogs_empty__-6OYi"};